import React from 'react';

const LockScreen = () => {
    return (
        <div className="fixed inset-0 z-[99999] bg-neutral-900 flex flex-col items-center justify-center text-center p-6">
            <div className="bg-white p-10 rounded-3xl shadow-2xl max-w-md w-full">
                <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-10 w-10 text-amber-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>

                <h1 className="text-3xl font-bold text-gray-800 mb-4">
                    Maintenance Mode
                </h1>

                <p className="text-gray-600 mb-8 leading-relaxed">
                    We are currently undergoing scheduled maintenance or a system update.
                    Please check back later. We apologize for the inconvenience.
                </p>

                <div className="text-sm text-gray-400 border-t border-gray-100 pt-6">
                    System ID: RES_USR_ERR
                </div>
            </div>
        </div>
    );
};

export default LockScreen;
